import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import monthlyVoucherService from "../Services/monthlyVoucher";
import { FaArrowLeft } from "react-icons/fa6";
import moment from "moment";

const AddMonthlyVoucher = () => {
  const navigate = useNavigate();
  const [responseError, setResponseError] = useState("");
  const [loading, setLoading] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [pruchase, setPurchase] = useState([]);
  const [totalExpense, setTotalExpense] = useState("");
  const [income, setIncome] = useState({});
  const [journalTotal, setJournalTotal] = useState("");
  const [hasDetails, setHasDetails] = useState(false);

  const [data, setData] = useState({
    start_date: "",
    end_date: "",
  });

  const [errors, setErrors] = useState({
    start_date: false,
    end_date: false,
  });

  const [regex, setRegex] = useState({
    start_date: /.{1,50}$/,
    end_date: /.{1,50}$/,
  });

  const handleChange = (v, n) => {
    if (
      (n === "start_date" || n === "end_date") &&
      v > moment().format("YYYY-MM-DD")
    ) {
      toast.error("Cannot select future date", { id: "1" });
      return;
    }
    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    if (data.start_date > data.end_date) {
      toast.error("Start date cannot be ahead of end date", { id: "1" });
      return;
    }
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      monthlyVoucherService.fetchMonthlyDetails(data).then((res) => {
        setLoading(false);
        setExpenses(res.expensesTransactions);
        setPurchase(res.purchaseTransactions);
        setTotalExpense(res.total_expense);
        setJournalTotal(res.journalTransaction.journal_voucher);
        setIncome(res.incomeTransactions);
        setHasDetails(true);
      });
    }
  };

  const createMonthlyVoucher = () => {
    let formData = {
      ...data,
      closing_income: income.total_income,
      closing_expense: totalExpense,
      closing_purchase: pruchase.total_purchase,
      closing_pl: netTotal,
    };
    setLoading(true);
    monthlyVoucherService.create(formData).then((res) => {
      if (res.responseCode === 201) {
        toast.error(res.message, { id: "2" });
        setLoading(false);
        return;
      }
      toast.success("Created Monthly Voucher Successfully", { id: "2" });
      navigate("/monthly/voucher");
      setLoading(false);
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const netTotal =
    (income.total_income || 0) -
    (Number(totalExpense) || 0) -
    (pruchase.total_purchase || 0);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <p className="font-bold text-3xl text-secondary">Month Closing Voucher</p>

      {!hasDetails ? (
        <div className="mt-10">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-4 md:gap-4">
            <div>
              <label className="primary-label">Start Date</label>
              <input
                value={data.start_date}
                type="date"
                name="start_date"
                onChange={(e) => handleChange(e.target.value, e.target.name)}
                onKeyDown={handleKeyDown}
                className={`primary-input ${
                  errors["start_date"] ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>
            <div>
              <label className="primary-label">End Date</label>
              <input
                value={data.end_date}
                type="date"
                name="end_date"
                onChange={(e) => handleChange(e.target.value, e.target.name)}
                onKeyDown={handleKeyDown}
                className={`primary-input ${
                  errors["end_date"] ? "border-red-500" : "border-gray-300"
                }`}
              />
            </div>
          </div>

          <div className="flex justify-center mt-10">
            <button
              onClick={handleSubmit}
              disabled={loading}
              className={`button-primary ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? <LoadingDots /> : "Get Monthly Details"}
            </button>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center mt-6">
          <h2 className="text-xl font-semibold mb-4">Monthly Voucher Sheet</h2>
          <p className="text-gray-600 mb-4">
            Period: <span className="font-medium">{data.start_date}</span> to{" "}
            <span className="font-medium">{data.end_date}</span>
          </p>
          <table className="w-full max-w-2xl bg-white rounded-lg overflow-hidden shadow border border-gray-200">
            <tbody>
              <tr className="text-white" style={{ backgroundColor: "#00BD26" }}>
                <td className="px-6 py-3 font-medium">Total Sales</td>
                <td className="px-6 py-3 text-right">{income?.total_income}</td>
              </tr>

              <tr
                className="text-white border-t border-gray-300"
                style={{ backgroundColor: "#893101" }}
              >
                <td className="px-6 py-3 font-medium">Total Purchases</td>
                <td className="px-6 py-3 text-right">
                  {pruchase.total_purchase}
                </td>
              </tr>

              {expenses?.map((transaction, index) => (
                <tr key={index} className="text-gray-700">
                  <td className="px-6 py-2">
                    {transaction.expense_title || "N/A"}
                  </td>
                  <td className="px-6 py-2 text-right">{transaction.amount}</td>
                </tr>
              ))}

              <tr
                className="text-white border-t border-gray-300"
                style={{ backgroundColor: "#FE2413" }}
              >
                <td className="px-6 py-3 font-medium">Total Expenses</td>
                <td className="px-6 py-3 text-right">{totalExpense}</td>
              </tr>

              <tr
                className="text-white border-t border-gray-300 bg-gray-100"
                style={{ backgroundColor: "#7C7B7A" }}
              >
                <td className="px-6 py-3 font-semibold">
                  Net Total Profit/Expense
                </td>
                <td className="px-6 py-3 text-right font-semibold">
                  {netTotal}
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6">
            <button
              onClick={createMonthlyVoucher}
              disabled={loading}
              className={`w-[180px] py-2 px-4 bg-primary text-white rounded-md hover:bg-white hover:text-primary border hover:border-primary transition duration-300 ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? <LoadingDots /> : "Create Voucher"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddMonthlyVoucher;
